import { Navigate } from "react-router-dom";
import {
  AUTH_TOKEN_KEY,
  clearAccessAuth,
  isPinAuthenticated,
  isTokenExpired,
} from "./utils/authSession";
import { useLocation } from "react-router-dom";
import {
  getDynamicPermissionForPath,
  hasAccess,
  isFixedPath,
} from "./config/permissionAccess";

export default function ProtectedRoute({ children, roles }) {
  const location = useLocation();
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isTokenExpired(token)) {
    clearAccessAuth();
    return <Navigate to="/login" replace />;
  }

  if (!isPinAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (roles?.length) {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const normalizedRole = String(user?.role || "").toLowerCase();
      const allowedRoles = roles.map((role) => String(role || "").toLowerCase());
      if (!allowedRoles.includes(normalizedRole)) {
        return <Navigate to="/unauthorized" replace />;
      }
    } catch {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  if (!isFixedPath(location.pathname)) {
    const dynamicPermissionId = getDynamicPermissionForPath(location.pathname);

    if (dynamicPermissionId) {
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const permissions = Array.isArray(user?.permissions) ? user.permissions : [];

        if (!hasAccess(dynamicPermissionId, permissions)) {
          return <Navigate to="/unauthorized" replace />;
        }
      } catch {
        return <Navigate to="/unauthorized" replace />;
      }
    }
  }

  return children;
}
